// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IEditorAudioNoteItem,
}                               from '../interfaces';

const getEditorAudioNoteItem = async ({
    test,
    mediaId,
    includeTranscript,
    previewSourceText,
    postId,
    chapterId,
    sectionId,
}: {
    test: boolean,
    mediaId: string,
    includeTranscript?: boolean,
    previewSourceText?: string,
    postId?: string,
    chapterId?: string,
    sectionId?: string,
}): Promise<IEditorAudioNoteItem | null> => {
    const functions = getFunctions();
    const handleGetEditorAudioNoteItem = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        IEditorAudioNoteItem | null
    >(
        functions,
        'getEditorAudioNoteItem',
    );
    return handleGetEditorAudioNoteItem({
        test,
        mediaId,
        ...(includeTranscript === false
            ? { includeTranscript: false }
            : {}),
        ...(typeof postId === 'string' && postId.trim().length > 0
            ? { postId }
            : {}),
        ...(typeof chapterId === 'string' && chapterId.trim().length > 0
            ? { chapterId }
            : {}),
        ...(typeof sectionId === 'string' && sectionId.trim().length > 0
            ? { sectionId }
            : {}),
        ...(typeof previewSourceText === 'string' && previewSourceText.trim().length > 0
            ? { previewSourceText }
            : {}),
    }).then((result) => {
        const item = result.data as IEditorAudioNoteItem | null;
        return item;
    }).catch((err) => {
        throw err;
    });
};

export default getEditorAudioNoteItem;
